import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Typography, Box} from '@mui/material';
import React, {useState} from 'react';
import * as XLSX from 'xlsx';

import CustomSnackbar from '../CustomSnackBar/CustomSnackBar';

const FileUpload = ({isFileUpload, setFileUpload, setValidating, setFileData, expectedHeaders, validationSchema}) => {
  const [snackbarAlert, setSnackBarAlert] = useState({isOpen: false, message: '', severity: 'error'});

  const validateRowData = (row) => {
    const isValid = validationSchema.validate(row);
    return {isValid: isValid.error ? false : true, error: isValid.error?.message || ''};
  };

  const validateFile = (data) => {
    return expectedHeaders?.length === data?.length && expectedHeaders.every((header) => data.includes(header));
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      const content = e.target.result;
      let data;
      if (file.name.endsWith('.csv')) {
        data = content.split('\r\n').map((row) => row.split(','));
      } else if (file.name.endsWith('.xlsx')) {
        const workbook = XLSX.read(content, {type: 'binary'});
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const options = {header: 1, defval: ''};
        data = XLSX.utils.sheet_to_json(worksheet, options);
      } else {
        setSnackBarAlert((prevState) => ({
          ...prevState,
          isOpen: true,
          message: 'Unsupported file format. Please upload a CSV or XLSX file.',
        }));
        setValidating(false);
        setFileData(null);
        return;
      }
      const headers = data[0].map((header) => header.trim());
      setValidating(true);
      if (!validateFile(headers)) {
        setSnackBarAlert((prevState) => ({
          ...prevState,
          isOpen: true,
          message: 'Invalid file. Please upload a file with the correct columns.',
        }));
        setFileData(null);
        setValidating(false);
        return;
      }
      const nonEmptyRows = data.filter((row) => row.some((cell) => cell !== null && cell !== undefined && cell !== ''));
      const sheetData = nonEmptyRows.slice(1).map((row) => {
        const rowData = {};
        row.forEach((cell, index) => (rowData[headers[index]] = cell));
        const validateRow = validateRowData(rowData);
        if (!validateRow.isValid) {
          rowData['message'] = validateRow.error;
          rowData['error'] = 1;
        }
        return rowData;
      });
      setValidating(false);
      setFileData(sheetData);
      setFileUpload(true);
    };
    reader.readAsBinaryString(file);
  };

  const closeSnackBarAlert = () => {
    setSnackBarAlert((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {!isFileUpload && (
        <Box display="flex" flexDirection="column" alignItems="center">
          <input type="file" accept=".csv, .xlsx" onChange={onFileChange} id="file-input" style={{display: 'none'}} />
          <label htmlFor="file-input" style={dropzoneStyles}>
            <CloudUploadIcon fontSize="large" />
            <Typography variant="body1" sx={{marginTop: 1, transition: 'margin-top 0.5s'}}>
              Click to select a CSV or XLSX file
            </Typography>
          </label>
        </Box>
      )}
      {snackbarAlert && (
        <CustomSnackbar
          autoHideDuration={5000}
          message={snackbarAlert.message}
          isOpen={snackbarAlert.isOpen}
          showCloseButton={true}
          handleClose={closeSnackBarAlert}
          isAlert={true}
          severity={snackbarAlert?.severity}
          anchorOriginVertical={'top'}
        />
      )}
    </Box>
  );
};

const dropzoneStyles = {
  border: '2px dashed #ccc',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
  boxSizing: 'border-box',
  marginTop: '20px',
};

export default FileUpload;
